class CartDrawer extends HTMLElement {

  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (event) => {
        if (
          event.code ===
          'Escape'
        ) {
          this.close();
        }
      }
    );


    this.addEventListener(
      'click',
      (event) => {
        const closeButton =
          event.target.closest(
            '[data-julu-cart-close]'
          );

        const overlay =
          event.target.closest(
            '#CartDrawer-Overlay'
          );


        if (
          !closeButton &&
          !overlay
        ) {
          return;
        }


        event.preventDefault();

        this.close();
      }
    );


    this.setHeaderCartIconAccessibility();
  }


  setHeaderCartIconAccessibility() {
    const cartLinks =
      document.querySelectorAll(
        '[data-julu-cart-open], #cart-icon-bubble'
      );

    cartLinks.forEach(
      (cartLink) => {
        if (
          cartLink.dataset
            .cartDrawerInitialized ===
          'true'
        ) {
          return;
        }

        cartLink.dataset
          .cartDrawerInitialized =
          'true';

        cartLink.setAttribute(
          'role',
          'button'
        );

        cartLink.setAttribute(
          'aria-haspopup',
          'dialog'
        );

        cartLink.setAttribute(
          'aria-controls',
          'CartDrawer'
        );

        cartLink.addEventListener(
          'click',
          (event) => {
            event.preventDefault();

            this.open(cartLink);
          }
        );

        cartLink.addEventListener(
          'keydown',
          (event) => {
            if (
              event.code !== 'Space' &&
              event.code !== 'Enter'
            ) {
              return;
            }

            event.preventDefault();

            this.open(cartLink);
          }
        );
      }
    );
  }


  open(triggeredBy) {
    if (
      this.classList.contains(
        'active'
      )
    ) {
      return;
    }

    if (triggeredBy) {
      this.setActiveElement(
        triggeredBy
      );
    }

    const cartDrawerNote =
      this.querySelector(
        '[id^="Details-"] summary'
      );

    if (
      cartDrawerNote &&
      !cartDrawerNote.hasAttribute(
        'role'
      )
    ) {
      this.setSummaryAccessibility(
        cartDrawerNote
      );
    }

    window.requestAnimationFrame(
      () => {
        this.classList.add(
          'animate',
          'active'
        );
      }
    );

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn =
          this.classList.contains(
            'is-empty'
          )
            ? this.querySelector(
              '.drawer__inner-empty'
            )
            : document.getElementById(
              'CartDrawer'
            );

        const focusElement =
          this.querySelector(
            '.drawer__inner'
          ) ||
          this.querySelector(
            '.drawer__close'
          );

        if (
          containerToTrapFocusOn &&
          focusElement
        ) {
          trapFocus(
            containerToTrapFocusOn,
            focusElement
          );
        }
      },
      {
        once: true
      }
    );

    document.body.classList.add(
      'overflow-hidden'
    );

    const drawerItems =
      this.querySelector(
        'cart-drawer-items'
      );

    if (
      typeof drawerItems
        ?.dispatchViewEvent ===
      'function'
    ) {
      drawerItems.dispatchViewEvent();
    }
  }


  close() {
    this.classList.remove(
      'active'
    );

    removeTrapFocus(
      this.activeElement
    );

    document.body.classList.remove(
      'overflow-hidden'
    );
  }


  setSummaryAccessibility(
    cartDrawerNote
  ) {
    cartDrawerNote.setAttribute(
      'role',
      'button'
    );

    cartDrawerNote.setAttribute(
      'aria-expanded',
      'false'
    );

    const controlledElement =
      cartDrawerNote
        .nextElementSibling;

    if (
      controlledElement?.id
    ) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        controlledElement.id
      );
    }

    cartDrawerNote.addEventListener(
      'click',
      (event) => {
        event.currentTarget.setAttribute(
          'aria-expanded',
          !event.currentTarget
            .closest('details')
            .hasAttribute('open')
        );
      }
    );

    cartDrawerNote
      .parentElement
      ?.addEventListener(
        'keyup',
        onKeyUpEscape
      );
  }


  renderContents(parsedState) {
    this.productId =
      parsedState.id;

    this.getSectionsToRender()
      .forEach((section) => {
        const sectionHTML =
          parsedState.sections?.[
          section.id
          ];

        if (!sectionHTML) {
          return;
        }

        const sectionElement =
          section.selector
            ? document.querySelector(
              section.selector
            )
            : document.getElementById(
              section.id
            );

        if (!sectionElement) {
          return;
        }

        const innerHTML =
          this.getSectionInnerHTML(
            sectionHTML,
            section.selector
          );

        if (innerHTML === null) {
          return;
        }

        sectionElement.innerHTML =
          innerHTML;
      });

    const drawerItems =
      this.querySelector(
        'cart-drawer-items'
      );

    const isEmpty =
      Boolean(
        drawerItems?.classList
          .contains('is-empty') ||
        this.querySelector(
          '.drawer__inner-empty'
        )
      );

    this.classList.toggle(
      'is-empty',
      isEmpty
    );

    const footer =
      this.querySelector(
        '.drawer__footer'
      );

    if (footer) {
      footer.hidden =
        isEmpty;
    }

    window.requestAnimationFrame(
      () => {
        this.dispatchEvent(
          new CustomEvent(
            'julu:cart:rendered',
            {
              bubbles: true
            }
          )
        );

        this.open();
      }
    );
  }


  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    if (!html) {
      return null;
    }

    const parsed =
      new DOMParser()
        .parseFromString(
          html,
          'text/html'
        );

    const element =
      parsed.querySelector(
        selector
      );

    return element?.innerHTML ??
      null;
  }


  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      }
    ];

    if (
      document.getElementById(
        'cart-icon-bubble'
      )
    ) {
      sections.push({
        id: 'cart-icon-bubble'
      });
    }

    return sections;
  }


  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    return new DOMParser()
      .parseFromString(
        html,
        'text/html'
      )
      .querySelector(selector);
  }


  setActiveElement(element) {
    this.activeElement =
      element;
  }
}


if (
  !customElements.get(
    'cart-drawer'
  )
) {
  customElements.define(
    'cart-drawer',
    CartDrawer
  );
}


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const sections = [
      {
        id: 'CartDrawer',
        section:
          'cart-drawer',
        selector:
          '.drawer__inner'
      }
    ];

    if (
      document.getElementById(
        'cart-icon-bubble'
      )
    ) {
      sections.push({
        id:
          'cart-icon-bubble',
        section:
          'cart-icon-bubble',
        selector:
          '.shopify-section'
      });
    }

    return sections;
  }
}


if (
  !customElements.get(
    'cart-drawer-items'
  )
) {
  customElements.define(
    'cart-drawer-items',
    CartDrawerItems
  );
}